const DATA_LIST_HOTEL_UPDATED = (state, dataListHotel) => {
  state.dataListHotel = dataListHotel
}

const SERVICES_UPDATED = (state, services) => {
  state.services = services
}

const IS_INVENTORY_LIST = (state, status) => {
  state.isInventoryList = status
}
export default {
  DATA_LIST_HOTEL_UPDATED,
  SERVICES_UPDATED,
  IS_INVENTORY_LIST
}
